import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

export default function QuickBooksConnectDialog({
  data,
  onClose,
  onConnect,
  onDisconnect,
}) {
  const isConnected = data?.isConnected || false;

  const handleConnect = () => {
    onConnect?.(data);
    onClose?.();
  };

  const handleDisconnect = () => {
    if (window.confirm("Are you sure you want to disconnect from QuickBooks?")) {
      onDisconnect?.(data);
      onClose?.();
    }
  };

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogTitle>
        {isConnected ? "QuickBooks Connection" : "Connect to QuickBooks"}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          {isConnected ? (
            <>
              <Alert severity="success">
                QuickBooks is connected for {data?.customerName || "this account"}
              </Alert>
              <Typography variant="body2" color="text.secondary">
                You can sync transactions and manage QuickBooks data integration.
              </Typography>
            </>
          ) : (
            <>
              <Alert severity="info">
                Connect to QuickBooks to sync transactions and financial data.
              </Alert>
              <Typography variant="body2" color="text.secondary">
                This will redirect you to QuickBooks for authorization. Once connected,
                you&apos;ll be able to sync transactions automatically.
              </Typography>
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        {isConnected ? (
          <Button onClick={handleDisconnect} color="error" variant="outlined">
            Disconnect
          </Button>
        ) : (
          <Button onClick={handleConnect} variant="contained">
            Connect to QuickBooks
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}